import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { concatMap, firstValueFrom, from, map, Observable, of, switchMap, toArray } from 'rxjs';

@Pipe({
    name: 'getImageUrl',
    standalone: true
})
export class GetImageUrlPipe implements PipeTransform {

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

    transform(value: string | undefined): Observable<string> {
        if (!value) {
            return of("Could not get description");
        }
        const regex = /<img\s+[^>]*src="([^"]+)"[^>]*>/g; // Regex to match img tags with src attributes
        const matches = value.matchAll(regex);

        return from(matches).pipe(
            concatMap(match => {
                const url = match[1];
                return this.getImageAsUrl(url).pipe(
                    map(blobUrl => ({
                        url,
                        blobUrl
                    }))
                );
            }),
            toArray(), // Collect all replacements into an array
            map(replacements => {
                // Replace URLs in the original string with the new blob URLs
                let updatedValue = value;
                replacements.forEach(({ url, blobUrl }) => {
                    updatedValue = updatedValue.replace(url, blobUrl);
                });
                return this.sanitizer.bypassSecurityTrustHtml(updatedValue) as string;
            })
        );
    }

    getImageAsUrl(url: string): Observable<string> {
        return this.http.get(url, { responseType: 'blob' }).pipe(
            switchMap((blob: Blob) => {
                // Create a URL from the blob and return it as an observable
                return of(URL.createObjectURL(blob));
            })
        );
    }
}
